// In this module we would place high order components which will contain others
// Routing, Initializers, Components which wait for an event to render something
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Switch, useHistory } from 'react-router-dom';
import { locale } from 'bv-i18n';

import { EmbeddedRoutesView, Layout, Services } from './features';
import { Route } from './features/routing/components/shared';

// Probably here we should call createStore
const { store } = window.reduxState;

const IndexSwitch = () => {
  window.reactRouterHistory = useHistory();
  return (
    <Switch>
      <Route path="/components">
        <EmbeddedRoutesView />
      </Route>
      <>
        <Layout />
        <Services />
      </>
    </Switch>
  );
};

export default () => (
  <Provider store={store}>
    <BrowserRouter basename={`/${locale()}`}>
      <IndexSwitch />
    </BrowserRouter>
  </Provider>
);
